import { Fragment } from 'react'

interface EventListProps {
  className?: string
  eventClassName?: string
  events: string[]
}

const EventList = ({ className, eventClassName, events }: EventListProps) => (
  <span className={className}>
    {events.map((eventName, index) => (
      <Fragment key={eventName}>
        {index > 0 && <span>/</span>}
        <code className={eventClassName}>{eventName}</code>
      </Fragment>
    ))}
  </span>
)

export default EventList
